<template>
  <div class="mjukaorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent></headComponent>
    <div class="order-tab">
      <span @click="toggle(0)" :class="{curt:0==active}">全部</span>
      <span @click="toggle(1)" :class="{curt:1==active}">待预约</span>
      <span @click="toggle(2)" :class="{curt:2==active}">已报名</span>
      <span @click="toggle(3)" :class="{curt:3==active}">已核销</span>
    </div>
    <div style="height:93px"></div>
    <ul>
      <li v-for="(item,i) in setOrder">
        <h2>
          <span>{{item.title}}</span>
          <font :style="item.status == 2 ? '' : (item.status == 1 ? 'background: #ECF2FE;color: #0052D9;' : 'background: #eee;color: #666;')">{{item.status == 1 ? '已报名' : (item.status == 2 ? '已核销' : '待报名')}}</font>
        </h2>

        <div class="email">
          订单编号
          <span>{{item.number}}</span>
        </div>
        <div class="email">
          报名姓名
          <span>{{item.name}}</span>
        </div>
        <div class="email">
          联系号码
          <span>{{item.phone}}</span>
        </div>
        <div class="email">
          报名时间
          <span>{{item.createtime}}</span>
        </div>
        <div style="height:12px"></div>
        <div class="btn">
          <a href="javascript:;" @click="setCode(item.number)">{{item.status == 1 ? '去核销' : '查看'}}</font></a>
        </div>
      </li>
    </ul>
    <div style="height:10px"></div>
    <div class="none" v-if="setOrder.length <= 0">
      <img src="~assets/images/none.png">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        userData:[],
        setOrder:[],
        curHeight:0,
        fullscreenLoading: true,
        active:0,
        baseUrl:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$hostApi;
      this.active = this.$route.query.id;
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent(this.$url+'/main/mjukaorder?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getOrder();
      }
    },

    methods: {
      toggle(index){
        this.active=index;
        this.getOrder();
      },
      setCode:function(id){
        this.$router.push({
          path:'mjukacode',
          query:{
            id:id
          }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true

        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getActiveOrder',
          dataType:'json',
          data:{
            user_id:that.userData.id,
            t:that.active
          },
          success:function(data){
            if(data.status == 200){
              that.setOrder = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.getOrder();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .mjukaorderApp{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }
  .mjukaorderApp .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:36px;
    background:#fff;
    z-index:99
  }
  .mjukaorderApp .order-tab span{
    display:inline-block;
    width:25%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    position:relative;
    color:#555
  }
  .mjukaorderApp .order-tab span.curt{
    color:#406DE1;
    font-weight:bold;
  }
  .mjukaorderApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:25px;
    height:2px;
    background:#406DE1;
    bottom:5px;
    left:50%;
    transform: translateX(-50%);
    border-radius:2px;
  }
  .mjukaorderApp ul{
    width:96%;
    margin:0 auto;
  }
  .mjukaorderApp ul li{
    background:#fff;
    width:100%;
    border-radius:6px;
    padding-bottom:12px;
    margin-bottom:12px
  }
  .mjukaorderApp ul li h2{
    height:50px;
    width:94%;
    margin:0 auto;
    font-size:16px;
    line-height:50px;
    border-bottom:solid 1px #ebebeb
  }
  .mjukaorderApp ul li h2 span{
    float:left;
    width:65%;
    height:50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#1C222B
  }
  .mjukaorderApp ul li h2 font{
    float:right;
    height:25px;
    font-weight:normal;
    font-size:14px;
    color:#E34D59;
    line-height:25px;
    background: #FDECEE;
    border-radius: 5px;
    padding:0 8px;
    margin-top:12px
  }
  .mjukaorderApp ul li .pro-item{
    width:94%;
    margin:10px auto 0 auto;
  }
  .mjukaorderApp ul li .pro-item:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .mjukaorderApp ul li .pro-item .proImg{
    width:60px;
    float:left;
    font-size:0
  }
  .mjukaorderApp ul li .pro-item  .proContent{
    float:left;
    width:calc(100% - 60px);
    height:70px;
    position:relative;
  }
  .mjukaorderApp ul li .pro-item  .proContent p{
    width:65%;
    margin-left:8px;
    font-size:15px;
    color:#1C222B;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    font-weight:500
  }
  .mjukaorderApp ul li .pro-item  .proContent .money{
    float:right;
    margin-top:14px
  }
  .mjukaorderApp ul li .pro-item  .proContent .money b{
    display:block;
    color:#1C222B;
    font-size:16px;
  }
  .mjukaorderApp ul li .pro-item  .proContent .money font{
    display:block;
    text-align:right;
    font-size:14px;
    color:#666
  }
  .mjukaorderApp ul li .amount{
    font-size:22px;
    font-weight:bold;
    text-align:right;
    width:94%;
    margin:0 auto 12px auto;
  }
  .mjukaorderApp ul li .amount font{
    font-size:14px;
  }
  .mjukaorderApp ul li .btn{
    width:94%;
    margin:0 auto;
    text-align:right;
  }
  .mjukaorderApp ul li .btn a{
    display:inline-block;
    width:90px;
    height:35px;
    line-height:35px;
    text-align:center;
    border: 1px solid #1C222B;
    color:#1C222B;
    border-radius: 35px;
    font-size:15px;
    text-decoration: none;
  }
  .mjukaorderApp .none{
    text-align:center;
    padding-top:50%;
  }
  .mjukaorderApp .none img{
    width:120px;
  }
  .mjukaorderApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }

  .mjukaorderApp .email{
    background:#fff;
    height:50px;
    line-height:50px;
    font-size:15px;
    color:#333;
    display:block;
    padding-left:4%;
    margin:0 auto;
    font-size: 15px;
    border-bottom:solid 1px #f5f5f5;
  }
  .mjukaorderApp .email span{
    color:#666;
    font-size: 15px;
    float:right;
    font-weight:normal;
    margin-right:4%
  }
</style>